import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
// import "./MarketOutlook.css";
// import animation from "../../images/jm-animation.gif";
import animation from "../../../images/jm-animation.gif";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
// import URLstateContext from "../../provider/CommonContext";
import URLstateContext from "../../../provider/CommonContext";

function BBB() {
  const [data, setData] = useState([]);
  const [loadingshow, setloadingshow] = useState(true);
  const [show, setShow] = useState(false);
  const [FetchDatavdo, setFetchDatavdo] = useState([]);
  const { BaseURL } = useContext(URLstateContext);

  useEffect(() => {
    // Fetch Market Outlook data when component mounts
    fetchMarketOutlookData();
  }, []);

  const clickyoutube = (event) => {
    setShow(true);
    fetchVideoLink(event);
  };

  const fetchMarketOutlookData = () => {
    // Fetch Market Outlook data from the API
    GetPostMethodData(BaseURL + "GetCommunicationHub", {
      IICategoryID: 5, // Assuming 2 is the ID for Market Outlook
      // IISubCategoryID: 0,
    }).then((responseData) => {
      if (responseData.data != null && responseData.data.length > 0) {
        setData(DecryptAESdata(responseData.data));
        setloadingshow(false);
      } else {
        setData([]);
        setloadingshow(false);
      }
    });
  };

  const fetchVideoLink = (event) => {
    GetPostMethodData(BaseURL + "GetVideoLink", {
      IVsrno: event,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setFetchDatavdo(DecryptAESdata(data.data));
      }
    });
  };

  const handleClosePopup = () => {
    setShow(false);
  };

  return (
    <>
      <section className="market-outlook-section">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="market-outlook-container">
                {data === null && loadingshow === false ? (
                  <h5 className="errormsgComNew">No Data Available !!!</h5>
                ) : (
                  data &&
                  data.map(({ Title, ThumbnailImage, CommunicationID }) => (
                    <div
                      className="market-outlook-item zoom"
                      key={CommunicationID}
                    >
                      <h3>{Title}</h3>
                      <span onClick={() => clickyoutube(CommunicationID)}>
                        <img
                          src={ThumbnailImage}
                          className="img-fluid"
                          alt="Thumbnail"
                        />
                      </span>
                    </div>
                  ))
                )}
                {loadingshow && (
                  <div className="textcentervertex">
                    <img src={animation} alt="Loading" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {FetchDatavdo.map(({ Title, LinkLocation }, index) => (
        <Modal show={show} className="modal modal-teams" key={index}>
          <Modal.Body id="modal_info">
            <div className="btnDiv">
              <div className="" onClick={handleClosePopup}>
                <AiFillCloseCircle className="btncl" />
              </div>
            </div>
            <div className="youtubepopup">
              <p>{Title}</p>
              <div>
                <iframe
                  className="iframe-vdo"
                  src={LinkLocation}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ))}
    </>
  );
}

export default BBB;
